/* Shazoo theme JS — no dependencies */
(() => {
  const S = window.Shazoo || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* ---------- helpers ---------- */
  const money = (cents) => {
    const fmt = S.moneyFormat || '£{{amount}}';
    const amt = (cents / 100).toFixed(2);
    const withComma = amt.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount\s*\}\}/, withComma).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100)).replace(/<[^>]+>/g, '');
  };
  const toast = (html, ms = 3500) => {
    const t = $('#toast'); if (!t) return;
    t.innerHTML = html; t.hidden = false;
    clearTimeout(t._h); t._h = setTimeout(() => (t.hidden = true), ms);
  };
  const debounce = (fn, ms) => { let h; return (...a) => { clearTimeout(h); h = setTimeout(() => fn(...a), ms); }; };
  const openDrawer = (el) => { if (!el) return; el.setAttribute('open', ''); document.body.style.overflow = 'hidden'; const f = $('[autofocus],input,button', el); f && f.focus(); };
  const closeDrawer = (el) => { if (!el) return; el.removeAttribute('open'); document.body.style.overflow = ''; };
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-drawer-open]'); if (t) { e.preventDefault(); openDrawer($(t.dataset.drawerOpen)); }
    const c = e.target.closest('[data-drawer-close]'); if (c) { e.preventDefault(); closeDrawer(c.closest('.drawer')); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { $$('.drawer[open]').forEach(closeDrawer); $('.zoom-modal.is-open')?.classList.remove('is-open'); } });

  /* ---------- header ---------- */
  const header = $('.header');
  if (header) window.addEventListener('scroll', () => header.classList.toggle('is-scrolled', window.scrollY > 8), { passive: true });
  // mega menus: hover on desktop, click toggles
  $$('.nav__item--has-menu').forEach((item) => {
    let h;
    item.addEventListener('mouseenter', () => { clearTimeout(h); $$('.nav__item.is-open').forEach(i => i !== item && i.classList.remove('is-open')); item.classList.add('is-open'); });
    item.addEventListener('mouseleave', () => { h = setTimeout(() => item.classList.remove('is-open'), 120); });
    $('.nav__link', item)?.addEventListener('click', (e) => { if (window.matchMedia('(hover:none)').matches) { e.preventDefault(); item.classList.toggle('is-open'); } });
  });
  document.addEventListener('click', (e) => { if (!e.target.closest('.nav__item')) $$('.nav__item.is-open').forEach(i => i.classList.remove('is-open')); });

  /* ---------- predictive search ---------- */
  $$('[data-predictive]').forEach((form) => {
    const input = $('input[name="q"]', form); const box = $('.predictive', form.parentElement);
    if (!input || !box || !S.predictiveSearch) return;
    const run = debounce(async () => {
      const q = input.value.trim(); if (q.length < 2) { box.hidden = true; return; }
      try {
        const r = await fetch(`${S.routes.predictive}?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6&section_id=predictive-search`);
        if (!r.ok) throw 0;
        const html = await r.text(); const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('#shopify-section-predictive-search')?.innerHTML || '';
        box.innerHTML = inner; box.hidden = !inner.trim();
      } catch { box.hidden = true; }
    }, 220);
    input.addEventListener('input', run);
    input.addEventListener('focus', () => { if (box.innerHTML.trim() && input.value.trim().length >= 2) box.hidden = false; });
    document.addEventListener('click', (e) => { if (!form.parentElement.contains(e.target)) box.hidden = true; });
  });

  /* ---------- cart ---------- */
  const cartCountEls = () => $$('[data-cart-count]');
  const refreshCartDrawer = async (open = false) => {
    if (!S.cartDrawer) return;
    const r = await fetch(`${S.routes.cart}?section_id=cart-drawer`); const html = await r.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('#CartDrawer'); const cur = $('#CartDrawer');
    if (fresh && cur) { cur.innerHTML = fresh.innerHTML; }
    const count = doc.querySelector('[data-cart-count]')?.dataset.cartCount || '0';
    cartCountEls().forEach(el => { el.textContent = count; el.dataset.cartCount = count; });
    if (open) openDrawer($('#CartDrawer'));
  };
  const addToCart = async (formData, btn) => {
    btn?.classList.add('is-loading'); btn && (btn.disabled = true);
    try {
      const r = await fetch(S.routes.cartAdd + '.js', { method: 'POST', body: formData, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const data = await r.json();
      if (!r.ok) { toast(data.description || data.message || 'Could not add to cart'); return false; }
      if (S.cartDrawer) await refreshCartDrawer(true);
      else { const c = await (await fetch(S.routes.cart + '.js')).json(); cartCountEls().forEach(el => { el.textContent = c.item_count; el.dataset.cartCount = c.item_count; }); toast(`Added to bag <a href="${S.routes.cart}">View bag</a>`); }
      return true;
    } catch { toast('Network error — please try again'); return false; }
    finally { btn?.classList.remove('is-loading'); btn && (btn.disabled = false); }
  };
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-ajax-cart]'); if (!form) return;
    e.preventDefault(); addToCart(new FormData(form), $('[type=submit]', form));
  });
  document.addEventListener('click', async (e) => {
    const q = e.target.closest('[data-quick-add]'); if (!q) return;
    e.preventDefault(); const fd = new FormData(); fd.append('id', q.dataset.quickAdd); fd.append('quantity', 1); addToCart(fd, q);
  });
  // quantity buttons + line changes
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-qty]'); if (!b) return;
    const input = $('input', b.closest('.qty')); const step = b.dataset.qty === '+' ? 1 : -1;
    const min = parseInt(input.min || '0', 10); let v = Math.max(min, (parseInt(input.value, 10) || 0) + step);
    input.value = v; input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('change', async (e) => {
    const input = e.target.closest('[data-line-qty]'); if (!input) return;
    await changeLine(input.dataset.lineQty, parseInt(input.value, 10) || 0);
  });
  document.addEventListener('click', async (e) => {
    const rm = e.target.closest('[data-line-remove]'); if (!rm) return;
    e.preventDefault(); await changeLine(rm.dataset.lineRemove, 0);
  });
  const changeLine = async (key, quantity) => {
    const r = await fetch(S.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
    if (!r.ok) { toast('Could not update the bag'); return; }
    if ($('#CartDrawer')) await refreshCartDrawer(false);
    if ($('.cart-page')) location.reload();
  };
  window.ShazooCart = { add: addToCart, refresh: refreshCartDrawer };

  /* ---------- product form / variants ---------- */
  $$('[data-product-form]').forEach((root) => {
    const data = JSON.parse($('[data-variants-json]', root)?.textContent || '[]');
    const idInput = $('input[name="id"]', root); const priceEl = $('[data-price]', root); const stockEl = $('[data-stock]', root);
    const btn = $('[data-atc]', root); const skuEl = $('[data-sku]', root);
    const inputs = $$('.swatch-list input, .variant-select select', root);
    const selected = () => inputs.filter(i => i.type !== 'radio' || i.checked).map(i => i.value);
    const find = () => {
      if (!inputs.length) return data.find(v => String(v.id) === idInput?.value) || data.find(v => v.available) || data[0];
      const sel = selected(); return data.find(v => v.options.every((o, i) => o === sel[i]));
    };
    const update = () => {
      const v = find(); if (!v) { btn && (btn.disabled = true, $('.label', btn).textContent = 'Unavailable'); return; }
      idInput.value = v.id; history.replaceState({}, '', `${location.pathname}?variant=${v.id}`);
      if (priceEl) priceEl.innerHTML = v.compare_at_price > v.price ? `<span class="price price--sale"><span class="price__current">${money(v.price)}</span><s>${money(v.compare_at_price)}</s></span>` : `<span class="price"><span class="price__current">${money(v.price)}</span></span>`;
      if (skuEl) skuEl.textContent = v.sku || '';
      if (btn) { btn.disabled = !v.available; $('.label', btn).textContent = v.available ? btn.dataset.labelAdd : btn.dataset.labelSoldout; }
      if (stockEl) { stockEl.className = 'pinfo__stock' + (!v.available ? ' pinfo__stock--out' : (v.inventory_quantity > 0 && v.inventory_quantity <= 5 ? ' pinfo__stock--low' : '')); stockEl.textContent = !v.available ? 'Sold out' : (v.inventory_quantity > 0 && v.inventory_quantity <= 5 ? `Only ${v.inventory_quantity} left — order soon` : 'In stock · ready to ship'); }
      if (v.featured_media?.id) { const th = $(`[data-media-id="${v.featured_media.id}"]`); th && th.click(); }
      // disable impossible option combos (single-level check)
      $$('.swatch-list', root).forEach((list, idx) => {
        $$('input', list).forEach(inp => {
          const opts = selected(); opts[idx] = inp.value;
          const ok = data.some(x => x.available && x.options.every((o, i) => o === opts[i]));
          inp.nextElementSibling?.classList.toggle('is-disabled', !ok);
        });
      });
    };
    inputs.forEach(i => i.addEventListener('change', update));
    update();
  });

  /* ---------- gallery ---------- */
  $$('[data-gallery]').forEach((g) => {
    const stage = $('.gallery__stage', g); const thumbs = $$('.gallery__thumbs button', g);
    thumbs.forEach(t => t.addEventListener('click', () => {
      thumbs.forEach(x => x.classList.remove('is-active')); t.classList.add('is-active');
      const tpl = $('template', t); if (tpl) { stage.querySelector('[data-media]')?.remove(); const node = tpl.content.cloneNode(true); stage.appendChild(node); }
    }));
    $('.gallery__zoom', g)?.addEventListener('click', () => {
      const img = $('[data-media] img', stage) || $('img', stage); if (!img) return;
      let m = $('.zoom-modal'); if (!m) { m = document.createElement('div'); m.className = 'zoom-modal'; m.innerHTML = '<button aria-label="Close">×</button><img alt="">'; document.body.appendChild(m); m.addEventListener('click', () => m.classList.remove('is-open')); }
      $('img', m).src = img.currentSrc || img.src; m.classList.add('is-open');
    });
    // swipe on mobile: scroll thumbs into view of active
  });

  /* ---------- hero slideshow (crossfade / slide, GPU-only transitions) ---------- */
  $$('[data-slideshow]').forEach((hero) => {
    const slides = $$('.slide', hero); if (slides.length < 2) return;
    const dots = $$('.hero__dots button', hero); const auto = parseInt(hero.dataset.autoplay || '0', 10);
    hero.style.setProperty('--autoplay', auto + 's');
    let i = 0, timer = null, busy = false;
    const go = (n, user) => {
      const next = (n + slides.length) % slides.length; if (next === i || busy) return;
      busy = true; setTimeout(() => (busy = false), 500);
      slides[i].classList.remove('is-active'); slides[i].classList.add('is-prev');
      const prevIdx = i; setTimeout(() => slides[prevIdx].classList.remove('is-prev'), 900);
      slides[next].classList.add('is-active'); i = next;
      dots.forEach((d, k) => { d.classList.toggle('is-active', k === i); d.setAttribute('aria-selected', k === i); });
      // restart dot progress animation
      const fill = dots[i]?.querySelector('.hero__dot-fill'); if (fill) { fill.style.transition = 'none'; fill.style.transform = 'scaleX(0)'; void fill.offsetWidth; fill.style.transition = ''; fill.style.transform = ''; }
      if (user) restart();
    };
    const start = () => { if (!auto || timer) return; hero.classList.remove('is-paused'); timer = setInterval(() => go(i + 1), auto * 1000); };
    const stop = () => { clearInterval(timer); timer = null; hero.classList.add('is-paused'); };
    const restart = () => { stop(); start(); };
    dots.forEach((d, k) => d.addEventListener('click', () => go(k, true)));
    $('.hero__arrow--prev', hero)?.addEventListener('click', () => go(i - 1, true));
    $('.hero__arrow--next', hero)?.addEventListener('click', () => go(i + 1, true));
    hero.addEventListener('mouseenter', stop); hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop); hero.addEventListener('focusout', start);
    hero.setAttribute('tabindex', '0');
    hero.addEventListener('keydown', (e) => { if (e.key === 'ArrowLeft') go(i - 1, true); if (e.key === 'ArrowRight') go(i + 1, true); });
    // touch swipe
    let sx = 0, sy = 0;
    hero.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    hero.addEventListener('touchend', (e) => { const dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? i + 1 : i - 1, true); }, { passive: true });
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    // pause when off-screen
    if ('IntersectionObserver' in window) new IntersectionObserver(([e]) => e.isIntersecting ? start() : stop(), { threshold: .2 }).observe(hero); else start();
  });

  /* ---------- sticky add to cart ---------- */
  const sticky = $('.sticky-atc'); const mainAtc = $('[data-atc]');
  if (sticky && mainAtc) {
    const io = new IntersectionObserver(([e]) => sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0), { threshold: 0 });
    io.observe(mainAtc);
    $('button', sticky)?.addEventListener('click', () => mainAtc.click());
  }

  /* ---------- collection filters (auto-submit) ---------- */
  $$('[data-filters]').forEach((form) => {
    form.addEventListener('change', debounce(() => form.requestSubmit ? form.requestSubmit() : form.submit(), 250));
    $('[data-filters-toggle]')?.addEventListener('click', () => form.closest('.filters')?.classList.toggle('is-open'));
    $('[data-filters-close]', form)?.addEventListener('click', () => form.closest('.filters')?.classList.remove('is-open'));
  });
  $('[data-sort]')?.addEventListener('change', (e) => { const u = new URL(location.href); u.searchParams.set('sort_by', e.target.value); u.searchParams.delete('page'); location.href = u; });

  /* ---------- reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((es) => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' });
    $$('[data-animate]').forEach(el => io.observe(el));
  }

  /* ---------- share ---------- */
  $('[data-share]')?.addEventListener('click', async (b) => {
    const url = location.href;
    if (navigator.share) { try { await navigator.share({ title: document.title, url }); } catch {} }
    else { await navigator.clipboard?.writeText(url); toast('Link copied'); }
  });

  /* ---------- recently viewed ---------- */
  try {
    const key = 'shazoo_recent'; const cur = JSON.parse(localStorage.getItem(key) || '[]');
    const h = $('[data-product-handle]')?.dataset.productHandle;
    if (h) { const next = [h, ...cur.filter(x => x !== h)].slice(0, 8); localStorage.setItem(key, JSON.stringify(next)); }
    const holder = $('[data-recent]');
    if (holder && cur.length) {
      Promise.all(cur.filter(x => x !== h).slice(0, 4).map(x => fetch(`/products/${x}?section_id=product-card-json`).then(r => r.ok ? r.text() : ''))).then(htmls => {
        const out = htmls.map(t => { const d = new DOMParser().parseFromString(t, 'text/html'); return d.querySelector('.card')?.outerHTML || ''; }).join('');
        if (out.trim()) { $('.grid', holder).innerHTML = out; holder.hidden = false; }
      });
    }
  } catch {}
})();
